

        <div class="container">
            <table class="table table-striped table-hover table-bordered"
                   *ngIf='patients && patients.length'>
                <thead class="thead thead-light">
                    <tr>                       
                        <th class="text-capitalize">First Name</th>
                        <th>Last Name</th>
                        <th>DOB</th>
                        <th>Address </th>
                        <th>Phone</th>
                        <th>Email Address</th>
                        <th>Gender</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor='let patient of patients'>                       
                        <td class="text-capitalize"> <a  [routerLink]="['/patientDetail', patient.id]">  {{patient.firstName}} </a></td>
                        <td class="text-capitalize">{{patient.lastName}}</td>
                        <td data-date-format="mm/dd/yyyy">{{patient.dob}}</td>
                        <td class="text-capitalize">{{patient.address?.firstLine}} {{patient.address?.secondLine}}, {{patient.address?.city}}, {{patient.address?.zip}}, {{patient.address?.state}}</td>
                        <td>{{patient.contact?.phones[0]?.number}}</td>
                        <td class="text-capitalize">{{patient.contact?.email}}</td>
                        <td>{{patient.gender}}</td>                                     
                    </tr>

                </tbody>
            </table>
        </div>
   
   
